import { SupabaseAuthAdapter } from '@lensora/auth'

// Singleton — one auth client for the entire app.
// Components import AuthClient interface, never this file directly.
export const authClient = new SupabaseAuthAdapter({
  url: import.meta.env['VITE_SUPABASE_URL'] as string,
  anonKey: import.meta.env['VITE_SUPABASE_ANON_KEY'] as string,
})
